import {
    lazyGetDiagnosticsLogState,
    lazyRegisterDiagnostics,
    DiagnosticsLogger,
} from 'owa-diagnostics';
import SearchDiagnosticsPanel from '../components/SearchDiagnosticsPanel';

export const SEARCH_DIAGNOSTICS_PANEL_KEY = 'Search';

const renderSearchDiagnosticsPanel = (): JSX.Element => {
    const searchDiagnosticsPanel = new SearchDiagnosticsPanel({});
    return searchDiagnosticsPanel.renderPanel();
};

// This diagnostics logger is supplied to the diagnostics panel
const diagnosticsLogger: DiagnosticsLogger<string> = {
    name: SEARCH_DIAGNOSTICS_PANEL_KEY,
    datapoints: [],
    type: 'Custom',
};

let initialized = false;

export default function ensureLoggerInitialized() {
    if (!initialized) {
        initialized = true;

        lazyGetDiagnosticsLogState.import().then(getDiagnosticsLogState => {
            lazyRegisterDiagnostics.importAndExecute(
                diagnosticsLogger,
                getDiagnosticsLogState(),
                renderSearchDiagnosticsPanel
            );
        });
    }
}
